const allowedPages = new Set(["executive", "store", "product"]);

// Regular navigation only; history restoration and Showroom remain independent.
export function resetReportScroll(page: string) {
  if (!allowedPages.has(page)) return;
  window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
    if (document.querySelector(`.app-shell.page-${page}`)) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }));
}

export function returnDialogFocus(opener: HTMLElement | null, panel: HTMLDialogElement | null) {
  if (panel?.open) panel.close();
  window.requestAnimationFrame(() => {
    if (!panel?.open && !document.querySelector("dialog[open]") && opener?.isConnected) opener.focus({ preventScroll: true });
  });
}

export function reportTotalScope(language: string): { label: string; note: string } {
  return ({
    tr: { label: "Dönem ve filtre toplamı", note: "Arama yalnızca satırları süzer. Toplam, seçili dönem ve sayfa filtrelerinin tamamına aittir." },
    en: { label: "Period and filter total", note: "Search filters rows only. The total covers the selected period and all page filters." },
    ru: { label: "Итог периода и фильтров", note: "Поиск отбирает только строки. Итог относится ко всему выбранному периоду и фильтрам страницы." },
    uz: { label: "Davr va filtrlar jami", note: "Qidiruv faqat qatorlarni saralaydi. Jami tanlangan davr va sahifadagi barcha filtrlarga tegishli." },
  } as Record<string, { label: string; note: string }>)[language] ?? reportTotalScope("tr");
}
